<app-item-base [open]="open">
  <p class="name" placement="right">
    受信日
  </p>
  <div class="edit-field">
    <select class="form-control-select" [(ngModel)]="this.searchParams.receipt_datetime" name="receiptDatetime"
      [ngClass]="{
    'search-active': searchParams.receipt_datetime !== '0'
  }">
      <option value="0" selected="">-</option>
      <option value="1">〜1日</option>
      <option value="2">〜2日</option>
      <option value="3">〜3日</option>
      <option value="4">〜4日</option>
      <option value="5">〜5日</option>
      <option value="6">〜6日</option>
      <option value="7">〜7日</option>
    </select>
  </div>

</app-item-base>